export const MOTION_SET_DURATION = 'MOTION_SET_DURATION';
export const MOTION_SET_TRANSITIONDELAY = 'MOTION_SET_TRANSITIONDELAY';
export const MOTION_SET_TRANSITIONSPEED = 'MOTION_SET_TRANSITIONSPEED';



// WEBPACK FOOTER //
// ./src/constants.js